module.exports = __webpack_public_path__ + "media/src/images/scene_birth_day-19665fd01d1a1f41777c17ad373f6dcb.svg";